/**
 * Русские подписи исхода события журнала.
 *
 * Сервер пишет закрытый набор `'success' | 'error'`
 * (`admin-action-audit.model.ts:3`), но словарь построен так же, как словарь
 * типов действия: неизвестное значение показывается сырой строкой, а не
 * прячется за общей заглушкой. Новый исход на сервере не ломает страницу.
 */
export const RESULT_LABELS: Record<string, string> = {
    success: "Успех",
    error: "Ошибка",
}

export const resolveResultLabel = (result: string): string => {
    return RESULT_LABELS[result] ?? result
}
